import { getProductFormField } from '../utils';
import Component, { ProductFormPhoneInputGroupProps } from './ProductFormPhoneInputGroup';
import { injectIntl } from 'react-intl';

export default getProductFormField<ProductFormPhoneInputGroupProps>(injectIntl(Component));
